import { useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULT = {
  brand_name: "HireStream",
  brand_logo_url: "",
  brand_primary: "#10B981",
  brand_accent: "#22C881",
  brand_secondary: "#22C881",
};

export function hexToHsl(hex) {
  if (!hex) return null;
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return null;
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hue, s, l = (max + min) / 2;
  if (max === min) { hue = s = 0; }
  else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: hue = (g - b) / d + (g < b ? 6 : 0); break;
      case g: hue = (b - r) / d + 2; break;
      default: hue = (r - g) / d + 4;
    }
    hue /= 6;
  }
  return `${Math.round(hue * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function applyBranding(b) {
  const root = document.documentElement;
  const primary = hexToHsl(b.brand_primary);
  if (primary) {
    root.style.setProperty("--primary", primary);
    root.style.setProperty("--ring", primary);
    root.style.setProperty("--chart-1", primary);
  }
}

export function useBranding() {
  const [brand, setBrand] = useState(DEFAULT);
  useEffect(() => {
    const fetchBrand = () => api.get("/tenant/branding")
      .then((r) => { const b = { ...DEFAULT, ...r.data }; setBrand(b); applyBranding(b); })
      .catch(() => applyBranding(DEFAULT));
    fetchBrand();
    window.addEventListener("branding-updated", fetchBrand);
    return () => window.removeEventListener("branding-updated", fetchBrand);
  }, []);
  return brand;
}
